import { ChevronRight, FileText, Layers, Sparkles } from 'lucide-react';

interface ActivityQuickActionsWidgetProps {
  onCreateClick: () => void;
  onCategoriesClick: () => void;
  onReportsClick: () => void;
}

export function ActivityQuickActionsWidget({
  onCreateClick,
  onCategoriesClick,
  onReportsClick,
}: ActivityQuickActionsWidgetProps) {
  return (
    <div className="card bg-surface border border-line rounded-[16px] p-5 shadow-2xs flex flex-col gap-4">
      <h3 className="text-base font-bold text-ink tracking-tight">Quick Actions</h3>

      <div className="flex flex-col gap-2.5">
        {/* Create Activity */}
        <button
          type="button"
          onClick={onCreateClick}
          className="group p-3 rounded-[12px] bg-surface-2/70 hover:bg-surface-2 border border-line/80 hover:border-indigo-500/40 transition-all flex items-center justify-between text-left cursor-pointer"
        >
          <div className="flex items-center gap-3">
            <span className="grid h-9 w-9 shrink-0 place-items-center rounded-[8px] bg-blue-500/15 text-blue-400 border border-blue-500/25">
              <Sparkles className="h-4.5 w-4.5" />
            </span>
            <div>
              <h4 className="text-sm font-bold text-ink group-hover:text-indigo-400 transition-colors">
                Create New Activity
              </h4>
              <p className="text-xs text-ink-3 font-medium">Plan a new class activity</p>
            </div>
          </div>
          <ChevronRight className="h-4 w-4 text-ink-3 group-hover:text-ink transition-colors" />
        </button>

        {/* Only opens the filter panel; there is no managing of types behind it */}
        <button
          type="button"
          onClick={onCategoriesClick}
          className="group p-3 rounded-[12px] bg-surface-2/70 hover:bg-surface-2 border border-line/80 hover:border-indigo-500/40 transition-all flex items-center justify-between text-left cursor-pointer"
        >
          <div className="flex items-center gap-3">
            <span className="grid h-9 w-9 shrink-0 place-items-center rounded-[8px] bg-purple-500/15 text-purple-400 border border-purple-500/25">
              <Layers className="h-4.5 w-4.5" />
            </span>
            <div>
              <h4 className="text-sm font-bold text-ink group-hover:text-purple-400 transition-colors">
                Filter activities
              </h4>
              <p className="text-xs text-ink-3 font-medium">By type, due date or status</p>
            </div>
          </div>
          <ChevronRight className="h-4 w-4 text-ink-3 group-hover:text-ink transition-colors" />
        </button>

        {/* Opens the marking screen of the newest activity, not a report */}
        <button
          type="button"
          onClick={onReportsClick}
          className="group p-3 rounded-[12px] bg-surface-2/70 hover:bg-surface-2 border border-line/80 hover:border-indigo-500/40 transition-all flex items-center justify-between text-left cursor-pointer"
        >
          <div className="flex items-center gap-3">
            <span className="grid h-9 w-9 shrink-0 place-items-center rounded-[8px] bg-amber-500/15 text-amber-400 border border-amber-500/25">
              <FileText className="h-4.5 w-4.5" />
            </span>
            <div>
              <h4 className="text-sm font-bold text-ink group-hover:text-amber-400 transition-colors">
                Review latest activity
              </h4>
              <p className="text-xs text-ink-3 font-medium">Open the newest activity's submissions</p>
            </div>
          </div>
          <ChevronRight className="h-4 w-4 text-ink-3 group-hover:text-ink transition-colors" />
        </button>
      </div>
    </div>
  );
}
